'use client';

import React, { FC, useEffect } from 'react';

interface MuxPlayerElement extends HTMLElement {
  pause?: () => void;
  play?: () => Promise<void>;
}

interface UserwayAccessibilityLinkProps {
  enableAccessibilityLabel: string;
}

const pauseAllMuxPlayers = () => {
  document
    .querySelectorAll<MuxPlayerElement>('mux-player')
    .forEach((player) => {
      if (player?.pause) {
        player.pause();
      }
    });
};

const playAllMuxPlayers = () => {
  document
    .querySelectorAll<MuxPlayerElement>('mux-player')
    .forEach((player) => {
      if (player?.play) {
        player.play();
      }
    });
};

const UserwayAccessibilityLink: FC<UserwayAccessibilityLinkProps> = ({
  enableAccessibilityLabel,
}) => {
  const userwayAccount = process.env.NEXT_PUBLIC_USERWAY_ACCOUNT;

  // This is a temporary fix to make the Userway "Pause Animations" feature compatible with Mux Player.
  // Per Level Access (Userway), this feature is near release. We may remove the fix as soon as it's available.
  useEffect(() => {
    if (!userwayAccount) return;

    document.addEventListener(
      'userway:feature_enabled_s13',
      pauseAllMuxPlayers,
    );
    document.addEventListener(
      'userway:feature_disabled_s13',
      playAllMuxPlayers,
    );

    return () => {
      document.removeEventListener(
        'userway:feature_enabled_s13',
        pauseAllMuxPlayers,
      );
      document.removeEventListener(
        'userway:feature_disabled_s13',
        playAllMuxPlayers,
      );
    };
  }, [userwayAccount]);

  if (!userwayAccount) {
    return null;
  }

  // The "userway-accessibility-trigger" ID is used to trigger the Userway widget, see UserwaySnippet.tsx
  return (
    <button
      id="userway-accessibility-trigger"
      type="button"
      className="font-bold underline"
      data-testid="userway-accessibility-link"
    >
      {enableAccessibilityLabel}
    </button>
  );
};

export default UserwayAccessibilityLink;
